export class UISetting {
    constructor(source) {
        this.useArrows = !!source.useArrows;
        this.Draggable = !!source.Draggable;
        this.Pagination = !!source.Pagination;
        this.autoLoop = {
            enabled: !!source.AutoLooping,
            duration: parseInt(source.TimeLooping)
        };
    }
}
//# sourceMappingURL=UISetting.js.map